import { render, staticRenderFns } from "./ProductCommercialTaxes.vue?vue&type=template&id=8b503fe0&scoped=true&"
import script from "./ProductCommercialTaxes.vue?vue&type=script&lang=js&"
export * from "./ProductCommercialTaxes.vue?vue&type=script&lang=js&"
import style0 from "./ProductCommercialTaxes.vue?vue&type=style&index=0&id=8b503fe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b503fe0",
  null
  
)

export default component.exports